module.exports = __webpack_public_path__ + "img/待审核.23be3776.png";